import { render, staticRenderFns } from "./VehicleTrimBotComponent.vue?vue&type=template&id=4dbf5839"
import script from "./VehicleTrimBotComponent.vue?vue&type=script&lang=ts"
export * from "./VehicleTrimBotComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports